import { apiConfig } from "./apiConfig";
import {
  buildGacTycPayload,
  filterGacTycAcceptances,
  filterGacTycRecords,
} from "../utils/tycBrands";

const getTycGac = async () => {
  const response = await apiConfig.get("/tyc");
  const data = Array.isArray(response.data) ? response.data : [];

  return {
    ...response,
    data: filterGacTycRecords(data),
  };
};

const createTyc = async (payload) => {
  return await apiConfig.post("/tyc", buildGacTycPayload(payload));
};

const updateTyc = async (id, payload) => {
  return await apiConfig.patch(`tyc/update/${id}`, buildGacTycPayload(payload));
};

const deleteTyc = async (id) => {
  return await apiConfig.delete(`tyc/delete/${id}`);
};

const acceptTyc = async (payload) => {
  return await apiConfig.post("/tyc/accept", payload);
};

const getTycAcceptGac = async () => {
  const response = await apiConfig.get("/tyc/accept/all");
  const data = Array.isArray(response.data) ? response.data : [];

  return {
    ...response,
    data: filterGacTycAcceptances(data),
  };
};

export {
  getTycGac,
  createTyc,
  deleteTyc,
  updateTyc,
  acceptTyc,
  getTycAcceptGac,
  getTycAcceptGac as getTycAccept,
};
